import {
  Alert,
  AlertFromJSON,
  BibliographyRealCreateRequest,
  BibliographyRealCreateRequestToJSON,
  BibliographyRealDetail,
  BibliographyRealDetailFromJSON,
  BibliographyRealUpdateRequest,
  BibliographyRealUpdateRequestToJSON,
  BibliographyTooli,
  BibliographyTooliFromJSON,
  CheckCollectionBookNumberRequest,
  CheckCollectionBookNumberRequestToJSON,
  CollectionOrderEditInfo,
  CollectionOrderEditInfoFromJSON,
  CheckCollectionOrderBookNumberRequest,
  CheckCollectionOrderBookNumberRequestToJSON,
  CollectionOrderInfo,
  CollectionOrderInfoFromJSON,
  CollectionRegistrationInfo,
  CollectionRegistrationInfoFromJSON,
  HTTPBody,
  OrderCollectionsRequest,
  OrderCollectionsRequestToJSON,
  RegistrationCollectionsRequest,
  RegistrationCollectionsRequestToJSON,
  SimpleBibliographyReal,
  SimpleBibliographyRealFromJSON,
  UpdateCollectionsOrderRequest,
  UpdateCollectionsOrderRequestToJSON,
  GetCollectionOrderEditInfoRequest,
  HTTPQuery,
  GetCollectionOrderEditInfoRequestToJSON,
  RegisterInterLibraryLoanCollectionRequest,
  RegisterInterLibraryLoanCollectionRequestToJSON,
  RegisterInterLibraryLoanBibliographyRequest,
  RegisterInterLibraryLoanBibliographyRequestToJSON,
  InterlibraryLoanBibliography,
  InterlibraryLoanBibliographyFromJSON,
  SimpleMagazineFromJSON,
  SimpleMagazine,
  UpdateSimpleMagazineRequestToJSON,
  UpdateSimpleMagazineRequest,
  GetOrderSelectionRequest,
  OrderSelection,
  OrderSelectionFromJSON,
  GetOrderSelectionRequestToJSON,
  BibliographyRealReserveSetGroup,
  BibliographyRealReserveSetGroupFromJSON,
  DownloadBibliographyMarcTooliRequest,
  DownloadBibliographyMarcTooliRequestToJSON
} from '@/api'
import {
  InterLibraryReceipt,
  InterLibraryReceiptFromJSON
} from '@/api/models/bibliography-real/InterLibraryReceipt'
import {
  ReceiptReserve,
  ReceiptReserveFromJSON
} from '@/api/models/receipt/ReceiptReserve'
import {
  GetBibliographyRealReserveSetGroupRequest,
  GetBibliographyRealReserveSetGroupRequestToJSON
} from '@/api/models/bibliography-real/GetBibliographyRealReserveSetGroupRequest'
import * as runtime from '../runtime'

export class BibliographyRealApi extends runtime.BaseAPI {
  /**
   * 書誌情報を取得する
   * 書誌情報取得
   */
  async getBibliography(
    id?: number,
    marcNo?: string
  ): Promise<BibliographyRealDetail> {
    const query = id !== undefined ? `id=${id}` : `marc_no=${marcNo}`
    const response = await this.requestGet(`/bibliographies-real?${query}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographyRealDetailFromJSON(jsonValue)
    ).value()
  }

  async getCollectionRegistrationInfo(
    bibliographyId: number
  ): Promise<CollectionRegistrationInfo[]> {
    const response = await this.requestGet(
      `/bibliographies-real/${bibliographyId}/collections-input`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(CollectionRegistrationInfoFromJSON)
    ).value()
  }

  async checkCollectionBookNumber(
    request: CheckCollectionBookNumberRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = CheckCollectionBookNumberRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies-real/collections-input-check',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async registrationCollections(
    bibliographyId: number,
    request: RegistrationCollectionsRequest
  ): Promise<ReceiptReserve[]> {
    const bodyParameters: HTTPBody = RegistrationCollectionsRequestToJSON(
      request
    )
    const response = await this.requestPost(
      `/bibliographies-real/${bibliographyId}/collections`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReceiptReserveFromJSON)
    ).value()
  }

  /**
   * 物理書誌簡易情報を取得する
   * 物理書誌簡易情報取得
   */
  async getSimpleBibliographyReal(id: number): Promise<SimpleBibliographyReal> {
    const response = await this.requestGet(`/bibliographies-real/${id}/simple`)
    return new runtime.JSONApiResponse(response, jsonValue =>
      SimpleBibliographyRealFromJSON(jsonValue)
    ).value()
  }

  async createBibliographyReal(
    request: BibliographyRealCreateRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = BibliographyRealCreateRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies-real',
      bodyParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.bibliography_id
    ).value()
  }

  async updateBibliographyReal(
    bibliographyId: number,
    request: BibliographyRealUpdateRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = BibliographyRealUpdateRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/bibliographies-real/${bibliographyId}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async deleteBibliographyReal(
    bibliographyId: number
  ): Promise<runtime.VoidApiResponse> {
    const response = await this.requestDelete(
      `/bibliographies-real/${bibliographyId}`
    )

    return new runtime.VoidApiResponse(response)
  }

  async deleteBibliographyRealCheck(bibliographyId: number): Promise<Alert[]> {
    const response = await this.requestPost(
      `/bibliographies-real/${bibliographyId}/check`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AlertFromJSON)
    ).value()
  }

  /**
   * 雑誌次号登録
   * @param bibliographySetId
   */
  async createNextVolume(
    bibliographySetId: number
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = {
      bibliography_set_id: bibliographySetId
    }
    const response = await this.requestPost(
      '/bibliographies-real/next-volume',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * TOOLi物理書誌を取得する
   * TOOLi物理書誌取得
   */
  async getBibliographyTooli(marcNo: string): Promise<BibliographyTooli> {
    const response = await this.requestGet(
      `/bibliographies-real/tooli/${marcNo}`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographyTooliFromJSON(jsonValue)
    ).value()
  }

  /**
   * TOOLi物理書誌MARCをダウンロードする
   * TOOLi物理書誌MARCダウンロード
   */
  async downloadBibliographyMarcTooli(
    request: DownloadBibliographyMarcTooliRequest
  ): Promise<runtime.VoidApiResponse> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(
        DownloadBibliographyMarcTooliRequestToJSON(request)
      ).filter(value => value[1] !== undefined)
    ) as HTTPQuery

    const response = await this.requestGet(
      `/bibliographies-real/tooli/${request.marcNo}/download`,
      queryParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 物理書誌情報レシート出力値取得
   */
  async getReceiptInfo(
    bibliographyRealId: number,
    collectionId?: number
  ): Promise<string> {
    const queryParameters: runtime.HTTPQuery = {}

    if (collectionId !== undefined) {
      queryParameters.collection_id = collectionId
    }

    const response = await this.requestGet(
      `/bibliographies-real/${bibliographyRealId}/receipt_info`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue).value()
  }

  /**
   * 資料発注情報を取得する
   *資料発注情報取得
   */
  async getCollectionOrderInfo(
    bibliographyRealId: number
  ): Promise<CollectionOrderInfo[]> {
    const response = await this.requestGet(
      `/bibliographies-real/${bibliographyRealId}/orders-input`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(CollectionOrderInfoFromJSON)
    ).value()
  }

  /**
   * 資料発注冊数入力をチェックする
   * 資料発注冊数入力チェック
   */
  async checkCollectionOrderBookNumber(
    request: CheckCollectionOrderBookNumberRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = CheckCollectionOrderBookNumberRequestToJSON(
      request
    )
    const response = await this.requestPost(
      `/bibliographies-real/${bodyParameters.id}/orders-input-check`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 資料を発注する
   * 資料発注
   */
  async orderCollections(request: OrderCollectionsRequest): Promise<number[]> {
    const bodyParameters: HTTPBody = OrderCollectionsRequestToJSON(request)
    const response = await this.requestPost(
      `/bibliographies-real/${bodyParameters.id}/orders`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.order_ids
    ).value()
  }

  /**
   * 資料発注編集情報を取得する
   * 資料発注編集情報取得
   */
  async getCollectionOrderEditInfo(
    request: GetCollectionOrderEditInfoRequest
  ): Promise<CollectionOrderEditInfo[]> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(GetCollectionOrderEditInfoRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      `/bibliographies-real/orders-edit`,
      queryParameters
    )
    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(CollectionOrderEditInfoFromJSON)
    ).value()
  }

  /**
   * 資料発注を更新する
   * 資料発注更新
   */
  async updateCollectionsOrder(
    request: UpdateCollectionsOrderRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateCollectionsOrderRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/bibliographies-real/orders`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 相互貸借資料を登録する
   * 相互貸借資料登録
   */
  async registerInterLibraryLoanCollection(
    request: RegisterInterLibraryLoanCollectionRequest
  ): Promise<InterLibraryReceipt> {
    const bodyParameters: runtime.HTTPBody = RegisterInterLibraryLoanCollectionRequestToJSON(
      request
    )
    const response = await this.requestPost(
      `/bibliographies-real/${request.id}/interlibrary-loan`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      InterLibraryReceiptFromJSON(jsonValue)
    ).value()
  }

  /**
   * 相互貸借書誌を登録する
   * 相互貸借書誌登録
   */
  async registerInterLibraryLoanBibliography(
    request: RegisterInterLibraryLoanBibliographyRequest
  ): Promise<number> {
    const bodyParameters: runtime.HTTPBody = RegisterInterLibraryLoanBibliographyRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies-real/interlibrary-loan',
      bodyParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.bibliography_real_id
    ).value()
  }

  /**
   * 相互貸借書誌情報を取得する
   * 相互貸借書誌情報取得
   */
  async getInterLibraryLoanBibliography(
    id: number
  ): Promise<InterlibraryLoanBibliography> {
    const response = await this.requestGet(
      `/bibliographies-real/${id}/interlibrary-loan`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      InterlibraryLoanBibliographyFromJSON(jsonValue)
    ).value()
  }

  /**
   * 雑誌簡易情報を取得する
   * 雑誌簡易情報取得
   */
  async getSimpleMagazine(id: number): Promise<SimpleMagazine> {
    const response = await this.requestGet(
      `/bibliographies-real/${id}/simple-magazine`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      SimpleMagazineFromJSON(jsonValue)
    ).value()
  }

  /**
   * 雑誌簡易情報を更新する
   * 雑誌簡易情報更新
   */
  async updateSimpleMagazine(
    request: UpdateSimpleMagazineRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateSimpleMagazineRequestToJSON(
      request
    )

    const response = await this.requestPut(
      `/bibliographies-real/${bodyParameters.id}/simple-magazine`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 書誌選定情報を取得する
   * 書誌選定情報取得
   */
  async getOrderSelection(
    request: GetOrderSelectionRequest
  ): Promise<OrderSelection[]> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(GetOrderSelectionRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(
      `/bibliographies-real/order-selection`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(OrderSelectionFromJSON)
    ).value()
  }

  /**
   * セット・グループ予約取得
   * セット・グループ予約を取得する
   */
  async getBibliographyRealReserveSetGroup(
    request: GetBibliographyRealReserveSetGroupRequest
  ): Promise<BibliographyRealReserveSetGroup> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(
        GetBibliographyRealReserveSetGroupRequestToJSON(request)
      ).filter(value => value[1] !== undefined)
    ) as HTTPQuery

    const response = await this.requestGet(
      `/bibliographies-real/${queryParameters?.id ?? ''}/reserve-set-group`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographyRealReserveSetGroupFromJSON(jsonValue)
    ).value()
  }
}
